var _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttribute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "attribute_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 14.998h-3V9h3C21.98 9 24 6.981 24 4.5A4.504 4.504 0 0019.5 0c-2.481 0-4.502 2.018-4.502 4.5v3H9v-3C9 2.019 6.981 0 4.501 0 2.02 0 0 2.018 0 4.5c0 2.484 2.018 4.502 4.5 4.502h3V15h-3A4.5 4.5 0 000 19.499a4.502 4.502 0 004.5 4.499c2.484 0 4.502-2.018 4.502-4.501V16.5H15v3c0 2.48 2.018 4.5 4.5 4.5a4.502 4.502 0 004.497-4.5c0-2.481-2.018-4.502-4.499-4.502zm-3-10.497c0-1.656 1.344-3 3-3 1.655 0 2.999 1.344 2.999 3 0 1.655-1.344 3-3 3h-3v-3zm-12 3c-1.655 0-2.999-1.345-2.999-3 0-1.656 1.344-3 3-3 1.655 0 3 1.344 3 3v3h-3zm3 11.998c0 1.656-1.344 3-3 3-1.655 0-2.999-1.347-2.999-3s1.344-3 3-3h3v3zM9 9h5.998v6H9v-6zm10.5 13.5c-1.656 0-3-1.344-3-3v-3h3c1.655 0 2.999 1.345 2.999 3 0 1.656-1.347 3-3 3z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#attribute_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 14.998h-3V9h3C21.98 9 24 6.981 24 4.5A4.504 4.504 0 0019.5 0c-2.481 0-4.502 2.018-4.502 4.5v3H9v-3C9 2.019 6.981 0 4.501 0 2.02 0 0 2.018 0 4.5c0 2.484 2.018 4.502 4.5 4.502h3V15h-3A4.5 4.5 0 000 19.499a4.502 4.502 0 004.5 4.499c2.484 0 4.502-2.018 4.502-4.501V16.5H15v3c0 2.48 2.018 4.5 4.5 4.5a4.502 4.502 0 004.497-4.5c0-2.481-2.018-4.502-4.499-4.502zm-3-10.497c0-1.656 1.344-3 3-3 1.655 0 2.999 1.344 2.999 3 0 1.655-1.344 3-3 3h-3v-3zm-12 3c-1.655 0-2.999-1.345-2.999-3 0-1.656 1.344-3 3-3 1.655 0 3 1.344 3 3v3h-3zm3 11.998c0 1.656-1.344 3-3 3-1.655 0-2.999-1.347-2.999-3s1.344-3 3-3h3v3zM9 9h5.998v6H9v-6zm10.5 13.5c-1.656 0-3-1.344-3-3v-3h3c1.655 0 2.999 1.345 2.999 3 0 1.656-1.347 3-3 3z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "attribute_svg__icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0h24v24H0V0z",
    fill: "#C4C4C4"
  }))));
}

export default __webpack_public_path__ + "./fonts/attribute.851d99843640a81bdb462166f8f45de2.svg";
export { SvgAttribute as ReactComponent };